import workbooksReducer from "./WorkbooksReducer"

const reducers = {
    workbooksReducer
};

export default reducers;